import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape({
  currentPassword: yup
    .string()
    .min(8, 'Min 8 symbols, 1 capital and 1 digit')
    .max(255, 'Min 8 symbols, 1 capital and 1 digit')
    .matches(/(.*[A-Z].*)(.*\d.*)|(.*\d.*)(.*[A-Z].*)/, 'Min 8 symbols, 1 capital and 1 digit')
    .required('Min 8 symbols, 1 capital and 1 digit'),
  newPassword: yup
    .string()
    .min(8, 'Min 8 symbols, 1 capital and 1 digit')
    .max(255, 'Min 8 symbols, 1 capital and 1 digit')
    .matches(/(.*[A-Z].*)(.*\d.*)|(.*\d.*)(.*[A-Z].*)/, 'Min 8 symbols, 1 capital and 1 digit')
    .required('Min 8 symbols, 1 capital and 1 digit'),
})

export const resolver = yupResolver(Schema)
